import AppModalsList from '@/components/AppModalsList/AppModalsList';

export default AppModalsList;
